import React, { useState } from "react";
import { Accordion, Card, Button } from "react-bootstrap";
import { useRecoilValue } from "recoil";
import Co2Process from "./Co2Process";
import ArrowDown from "../Process/components/ArrowDown";
import { ProcessFlag } from "atoms/General/index.js";
import { toast } from "react-toastify";
import TooltipTrippy from "app/components/ProductionScenario/TooltipTrippy";
import Co2PricingAnalysis from "./Co2PricingAnalysis";

const CarbonPricingPolymer = ({ ScenarioState, socket }) => {
  const [activeState, setActiveState] = useState(-1);
  const processFlag = useRecoilValue(ProcessFlag);

  const toggleState = (idnum) => {
    const id = idnum;
    if (activeState === +id) {
      setActiveState(null);
    } else {
      setActiveState(+id);
    }
  };

  return (
    <>
      <Accordion>
        <div className="mb-40">
          {processFlag.Transportation && (
            <>
              <div className="table-title-border mb-24">
                <span className="font-24 font-semi-bold">
                  Carbon Content Per Part
                </span>
              </div>
              <div className="d-flex flex-wrap gap-20 ">
                <Co2PricingAnalysis Socket={socket} />
              </div>
            </>
          )}
        </div>
        <div className="mb-40">
          <div className="table-title-border mb-24">
            <span className="font-24 font-semi-bold">Pricing Analysis</span>
          </div>
          <div className="d-flex flex-wrap gap-20 ">
            <Co2Process Socket={socket} />
          </div>
        </div>
      </Accordion>
      {/* <button
        onClick={() => {
          if (processFlag.CarbonPricing) {
            ScenarioState();
          } else {
            toast.error("Please fill all carbon pricing details.");
          }
        }}
        className="selection-button step-button"
      >
        Proceed
      </button> */}
    </>
  );
};

export default CarbonPricingPolymer;
